import API from '@/lib/API.js'
import comun from './comun.js'
const credenciales = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_item == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_item: 0,
                id_afiliado: 0,
                lote: 0,
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_item != 0) {
                data = await API.Credenciales.modificar(state.Seleccionado);
                str += "Credencial modificada"
            } else {
                data = await API.Credenciales.alta(state.Seleccionado);
                str += `Nueva credencial de alta`
            }
            let secs = await API.Credenciales.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_item)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_item != 0) {
                data = await API.Credenciales.modificar(entidad);
                str += "Credencial modificada"
            } else {
                data = await API.Credenciales.alta(entidad);
                str += `Nueva credencial de alta`
            }
            let secs = await API.Credenciales.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_item)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Credenciales.eliminar(id);
                str += "Credencial eliminada"
            }
            commit("comun/mostrar", str)
        },
        async traerUltimaPorAfiliado({
            commit
        }, id_afiliado) {
            commit("select", await API.Credenciales.traerUltimaPorAfiliado(id_afiliado))
        },
    },
    getters: {
        getCredenciales: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default credenciales;